import React from "react";
// @ts-ignore
import { Link } from "react-router-dom";

import { RowDiv } from "../styledComponents/CustomStyledComponents";
import ImageComponent from "../imageEconomicResearch/EconomicResearchImageComponent";
import Images from "../../assets/images/Images";
import {Trans, useTranslation} from "react-i18next";

const FooterTitleComponent: React.FC<{title?: string}> = ({title}) => {
    const { t } = useTranslation();

    return(
        <div style={{display: 'flex', flex: '1 1 50%', marginTop: 50}}>
            <div style={{flex: 6, fontSize: 50, fontWeight: "bold", display: 'block', lineHeight: 1, verticalAlign: 'top', height: '100%'}}>
                { t('economicResearch.footerSection.title1') } <br /> { t('economicResearch.footerSection.title2') }
            </div>
            <div style={{flex: 2}}></div>
        </div>
    )
};

const SeparatorComponent: React.FC = () => {
    return (
        <div style={{flex: '1 1 auto', marginTop: 25, marginLeft: 5}}>
            <div style={{flex: 0.15}}></div>
            <div style={{flex: 0, borderTop: '4px solid', marginTop: 5, width: 50}}></div>
            <div style={{flex: 0.15}}></div>
        </div>
    )
};

const TextComponent: React.FC<{text?: string}> = () => {
    return (
        <div style={{flex: '1 1 auto', display: 'flex', flexDirection: 'row', marginTop: 25}}>
            <div style={{flex: 6, paddingLeft: 5, fontFamily: 'DMSans-Light'}}>
              <Trans i18nKey='economicResearch.footerSection.description'>
                Description <a href="https://www.mapfre.com/informacion-sectorial/indice-global-potencial-asegurador/" target='_blank'>página</a>
              </Trans>
            </div>
            <div style={{flex: 2}}></div>
        </div>
    )
};


const FooterContentComponent: React.FC = () => {
    return(
        <RowDiv style={{alignItems: 'flex-start'}}>
            <RowDiv style={{flex: '1 1 50%', justifyContent: 'center'}}>
                <ImageComponent image={Images.homeImage2} />
            </RowDiv>
            <div style={{flex: '1 1 50%', display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                <FooterTitleComponent />
                <SeparatorComponent />
                <TextComponent />
            </div>
        </RowDiv>
    );
};

export default FooterContentComponent;
